import { useState, useEffect } from "react";

type IHighContrast = [boolean];

const useHighContrast = (): IHighContrast => {
    const [isHighContrast, setIsHighContrast] = useState(false);

    useEffect(() => {
        const checkHighContrast = () => {
            if (typeof document !== "undefined") {
                const isHC = document.documentElement.classList.contains("dark");
                setIsHighContrast(isHC);
            }
        };

        checkHighContrast();

        const observer = new MutationObserver(checkHighContrast);

        if (typeof document !== "undefined") {
            observer.observe(document.documentElement, {
                attributes: true,
                attributeFilter: ["class"],
            });
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    return [isHighContrast];
};

export default useHighContrast;
